import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Col, Button } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ModalUI from '../../../../../shared/components/Modal';
import Modal from '@material-ui/core/Modal';

const styles = theme => ({
    date: {
        margin: 10,
        width: 215
    },
});

class BasicDataPatient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeOfDocument: '',
            documentNumber: '',
            id_patient: '',
            names: '',
            firstLastName: '',
            secondLastName: '',
            gender: '',
            address: '',
            email: '',
            cellphone: '',
            telephone1: '',
            telephone2: '',
            bloodType: '',
            date: new Date(),
            birthday: new Date(),
            civilStatus: '',
            race: '',
            races: [],
            ethnicity: '',
            ethnicities: [],
            country: '',
            department: '',
            departments: [],
            city: '',
            id_city: '',
            cities: [],
            regime: '',
            regimes: [],
            exist: false,
            errors: {},
            error: false,
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
            load: false,
            profile: sessionStorage.getItem('perfil'),
            disabled: true,
            photo: `${process.env.PUBLIC_URL}/img/man-1280.png`,
            zone: '',
            dateStart: ''
        }
    }

    handlerDocumentNumber = (number) => {
        this.setState({ documentNumber: number }, () => {
            //this.loadDataPatient();
        });
    }

    handlerTypeOfDocument = (type) => {
        this.setState({ typeOfDocument: type });
    }

    handlerNames = (names) => {
        this.setState({ names: names });
    }

    handlerFirstLastName = (name) => {
        this.setState({ firstLastName: name });
    }


    handlerSecondLastName = (name) => {
        this.setState({ secondLastName: name });
    }

    handlerGender = (gender) => {
        this.setState({ gender: gender });
    }

    handlerBirthDate = (birthday) => {
        this.setState({ birthday: birthday });
    };

    handlerCivilStatus = (status) => {
        this.setState({ civilStatus: status });
    }

    handlerRace = (race) => {
        this.setState({ race: race });
    }

    handlerEthnicity = (ethnicity) => {
        this.setState({ ethnicity: ethnicity })
    }

    handlerCountry = (country) => {
        this.setState({ country: country });
    }

    handlerDepartment = (department) => {
        this.setState({ department: department });
    }

    handlerCity = (city) => {
        this.setState({ city: city });
    }

    handlerAddress = (address) => {
        this.setState({ address: address });
    }

    handlerTelephoneOne = (telephone) => {
        this.setState({ telephone1: telephone })
    };


    handlerTelephoneTwo = (telephone) => {
        this.setState({ telephone2: telephone })
    };

    handlerCellphone = (cellphone) => {
        this.setState({ cellphone: cellphone })
    };

    handlerEmail = (email) => {
        this.setState({ email: email });
    };

    handlerRegime = (regime) => {
        this.setState({ regime: regime })
    }

    handlerBloodType = (bloodType) => {
        this.setState({ bloodType: bloodType });
    }

    componentDidMount = () => {
        //console.log(this.props);
        this.setState({ load: true }, () => {
            Promise.all([this.loadClientAndActivity(), this.LoadRaces(), this.LoadEthnicities(), this.loadRegimes(), this.loadDepartment()]).then((results) => {
                this.setState({ serter: results[0], races: results[1], ethnicities: results[2], regimes: results[3], departments: results[4] }, () => {
                    this.setState({ documentNumber: this.props.num_documento }, () => {
                        this.loadDataPatient()
                    });
                });
            }).catch((error) => {
                console.log(error);
            })
        })
    };

    loadClientAndActivity = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        })
    }

    loadDataPatient = () => {
        var data = { num_documento: this.state.documentNumber };

        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.existe) {
                    console.log(data.contenido)
                    this.loadCities(data.contenido[0].direccion.id_departamento).then((cities) => {
                        this.setState({ cities: cities }, () => {
                            this.setState({
                                id_patient: data.contenido[0].id_paciente,
                                typeOfDocument: data.contenido[0].tip_documento,
                                names: data.contenido[0].nombres,
                                firstLastName: data.contenido[0].apellido1,
                                secondLastName: data.contenido[0].apellido2,
                                gender: data.contenido[0].sexo,
                                address: data.contenido[0].direccion.direccion,
                                department: data.contenido[0].direccion.id_departamento,
                                city: data.contenido[0].direccion.id_ciudad,
                                id_city: data.contenido[0].direccion.id_ciudad,
                                country: data.contenido[0].direccion.id_pais,
                                email: data.contenido[0].correo,
                                cellphone: data.contenido[0].celular,
                                telephone1: data.contenido[0].telefono1,
                                telephone2: data.contenido[0].telefono2,
                                bloodType: data.contenido[0].tipo_sangre,
                                birthday: data.contenido[0].fec_nacimiento,
                                civilStatus: data.contenido[0].e_civil,
                                ethnicity: data.contenido[0].id_etnia,
                                race: data.contenido[0].id_raza,
                                regime: data.contenido[0].id_regimen,
                                zone: data.contenido[0].zona,
                                id_history: data.contenido[0].id_historia,
                                dateStart: data.contenido[0].fec_ingreso,
                                exist: true,
                                update: true,
                                load: false
                            });
                        })
                    });
                } else {
                    console.log("Usuario no existe!");
                    this.setState({
                        id_patient: '',
                        names: '',
                        firstLastName: '',
                        secondLastName: '',
                        gender: '',
                        address: '',
                        email: '',
                        cellphone: '',
                        telephone1: '',
                        birthday: new Date(),
                        department: '',
                        exist: false,
                        load: false
                    })
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadPlans = (tercero) => {
        var data = { id: tercero.id_tercero };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    this.setState({ plans: data.contenido, activities: [], activity: {} });
                } else {
                    this.setState({ plans: [], plan: {}, activities: [], activity: {} });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    loadActivities = (tercero, plan) => {
        var data = { id_tercero: tercero.id_tercero, id_plan: plan.id_plan };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    this.setState({ activities: data.contenido[0].servicios.servicios });
                } else {
                    this.setState({ activities: [], activity: {} });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    LoadEthnicities = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'etnia/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        })
    }

    LoadRaces = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'raza/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        })
    }

    loadRegimes = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'regimen/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    reject(error);
                });
        });
    }

    loadDepartment = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    resolve(error);
                });
        });
    }

    loadCities = (depcod) => {
        var data = { id_dpto: depcod };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    validateData = () => {
        var errors = this.state.errors;
        var error = false;

        if (this.state.typeOfDocument === "") {
            errors.typeOfDocument = "Seleccione un tipo de documento";
            error = true;
        } else {
            errors.typeOfDocument = "";
        }

        if (this.state.documentNumber === "") {
            errors.documentNumber = "Ingrese un número de documento";
            error = true;
        } else {
            errors.documentNumber = "";
        }

        if (this.state.names === "") {
            errors.names = "Ingrese al menos un nombre";
            error = true;
        } else {
            errors.names = "";
        }

        if (this.state.firstLastName === "") {
            errors.firstLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.firstLastName = "";
        }

        if (this.state.secondLastName === "") {
            errors.secondLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.secondLastName = "";
        }

        if (this.state.gender === "") {
            errors.gender = "Seleccione un genero";
            error = true;
        } else {
            errors.gender = "";
        }

        if (moment(this.state.birthday).format("YYYY/MM/DD") === moment(new Date()).format("YYYY/MM/DD")) {
            errors.birthday = "Seleccione una fecha";
            error = true;
        } else {
            errors.birthday = "";
        }

        if (this.state.country === "") {
            errors.country = "Seleccione un país";
            error = true;
        } else {
            errors.country = "";
        }

        if (this.state.department === "") {
            errors.department = "Seleccione un departamento";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.city === "") {
            errors.city = "Seleccione una ciudad";
            error = true;
        } else {
            errors.department = "";
        }

        if (this.state.address === "") {
            errors.address = "Ingrese una dirección";
            error = true;
        } else {
            errors.address = "";
        }

        if (this.state.telephone1 === "") {
            errors.telephone1 = "Ingrese una dirección";
            error = true;
        } else {
            errors.telephone1 = "";
        }

        if (this.state.cellphone === "") {
            errors.cellphone = "Ingrese una dirección";
            error = true;
        } else {
            errors.cellphone = "";
        }


        if (this.state.email === "") {
            errors.email = "Ingrese una dirección";
            error = true;
        } else {
            errors.email = "";
        }

        if (this.state.civilStatus === "") {
            errors.civilStatus = "Seleccione un estado civil";
            error = true;
        } else {
            errors.civilStatus = "";
        }

        if (this.state.race === "") {
            errors.race = "Seleccione un raza";
            error = true;
        } else {
            errors.race = "";
        }

        if (this.state.ethnicity === "") {
            errors.ethnicity = "Seleccione etnia";
            error = true;
        } else {
            errors.ethnicity = "";
        }

        if (this.state.bloodType === "") {
            errors.bloodType = "Seleccione etnia";
            error = true;
        } else {
            errors.bloodType = "";
        }

        this.setState({ errors: errors, error: error });
    }


    updatePatient = () => {

        let data = {
            ape1: this.state.firstLastName,
            ape2: this.state.secondLastName,
            nombres: this.state.names,
            sexo: this.state.gender,
            fec_nacimiento: this.state.birthday,
            direccion: {
                id_pais: '00038',
                departamento: this.state.department,
                id_departamento: this.state.departments.filter((department) => department.depcod === this.state.department)[0].depnom,
                ciudad: this.state.city,
                id_ciudad: this.state.id_city,
                direccion: this.state.address,
            },
            telefono1: this.state.telephone1,
            telefono2: this.state.telephone2,
            celular: this.state.cellphone,
            correo: this.state.email,
            e_civil: this.state.civilStatus,
            id_etnia: this.state.ethnicity,
            id_raza: this.state.race,
            id_regimen: this.state.regime,
            tipo_sangre: this.state.bloodType,
            //fec_ingreso: this.state.dateStart,
            id_paciente: this.state.id_patient,
            id_historia: this.state.id_history,
            zona: this.state.zone
        };

        console.log(data);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
                //return response.text();
            })
            .then(data => {
                //console.log(data);
                this.setState({
                    openAlert: true,
                    modalAlert: {
                        message: "Paciente actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <Col>
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                    <h5>Datos Básicos</h5>
                </div>
                <div style={{ flex: 1, flexDirection: 'row' }}>
                    <FormControl
                        className={classes.date}
                        error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                    >
                        <InputLabel required id="demo-simple-select-label" >Tipo de Documento</InputLabel>
                        <Select

                            labelId="demo-simple-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.typeOfDocument}
                            disabled={this.state.disabled}
                            onChange={(event) => {
                                console.log(event);
                                this.handlerTypeOfDocument(event.target.value);
                            }}
                            error={this.state.errors.hasOwnProperty("typeOfDocument") ? this.state.errors.typeOfDocument !== "" : false}
                        >
                            <MenuItem className="material-form__option" key={0} value={''}>Ninguno</MenuItem>
                            <MenuItem className="material-form__option" key={1} value={'TI'}>TI-Tarjeta de Identidad</MenuItem>
                            <MenuItem className="material-form__option" key={2} value={'CC'}>CC-Cedula de Ciudadania</MenuItem>
                            <MenuItem className="material-form__option" key={3} value={'PA'}>PA-Pasaporte</MenuItem>
                            <MenuItem className="material-form__option" key={4} value={'RC'}>RC-Registro Civil</MenuItem>
                            <MenuItem className="material-form__option" key={5} value={'CE'}>CE-Cedula de Extranjeria</MenuItem>
                            <MenuItem className="material-form__option" key={6} value={'MS'}>MS-Menor sin Identificación</MenuItem>
                            <MenuItem className="material-form__option" key={7} value={'AS'}>AS-Adulto sin Identificación</MenuItem>
                            <MenuItem className="material-form__option" key={8} value={'SC'}>SC-Salvo Conducto</MenuItem>
                            <MenuItem className="material-form__option" key={9} value={'CD'}>CD-Carnet Diplomatico</MenuItem>
                            <MenuItem className="material-form__option" key={10} value={'CN'}>CN-Certificado de Nacido Vivo</MenuItem>
                            <MenuItem className="material-form__option" key={11} value={'NI'}>NI-Número Identificación Tributario NIT</MenuItem>
							<MenuItem className="material-form__option" key={12} value={'PE'}>PE-Permiso Especial de Permanencia</MenuItem>
							<MenuItem className="material-form__option" key={13} value={'PT'}>PT-Permiso por Protección Temporal</MenuItem>
                            <MenuItem className="material-form__option" key={14} value={'SI'}>SI-Sin Identificación</MenuItem>
                        </Select>
                        <FormHelperText>{this.state.errors.typeOfDocument}</FormHelperText>
                    </FormControl>
                    <TextField
                        required
                        className={classes.date}
                        id="document-number-standard-required"
                        label="N° de documento"
                        type="number"
                        value={this.state.documentNumber}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerDocumentNumber(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("documentNumber") ? this.state.errors.documentNumber !== "" : false}
                        helperText={this.state.errors.documentNumber}
                    />
                    <img style={{ width: '7%', marginLeft: 500, border: '3px solid rgba(0, 0, 0, 0.05)' }} src={this.state.photo} alt="avatar" />
                </div>
                <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                    <TextField
                        required
                        className={classes.date}
                        id="names-standard-required"
                        label="Nombres"
                        type="text"
                        value={this.state.names}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerNames(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("names") ? this.state.errors.names !== "" : false}
                        helperText={this.state.errors.names}
                    />
                    <TextField
                        required
                        className={classes.date}
                        id="first-last-name-standard-required"
                        label="Primer Apellido"
                        type="text"
                        value={this.state.firstLastName}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerFirstLastName(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("firstLastName") ? this.state.errors.firstLastName !== "" : false}
                        helperText={this.state.errors.firstLastName}
                    />
                    <TextField
                        required
                        className={classes.date}
                        id="second-last-name-standard-required"
                        label="Segundo Apellido"
                        type="text"
                        disabled={this.state.disabled}
                        value={this.state.secondLastName}
                        onChange={(e) => {
                            this.handlerSecondLastName(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("secondLastName") ? this.state.errors.secondLastName !== "" : false}
                        helperText={this.state.errors.secondLastName}
                    />
                </div>
                <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                    <TextField
                        required
                        className={classes.date}
                        id="email-standard-required"
                        label="Correo Electrónico"
                        type="email"
                        value={this.state.email}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerEmail(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("email") ? this.state.errors.email !== "" : false}
                        helperText={this.state.errors.email}
                    />


                    <FormControl
                        className={classes.date}
                        error={this.state.errors.hasOwnProperty("gender") ? this.state.errors.gender !== "" : false}
                    >
                        <InputLabel required id="demo-simple-select-label">Genero</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            disabled={this.state.disabled}
                            value={this.state.gender}
                            onChange={(event) => {
                                this.handlerGender(event.target.value);
                            }}
                            error={this.state.errors.hasOwnProperty("gender") ? this.state.errors.gender !== "" : false}
                        >
                            <MenuItem key={0} value={''}>Ninguno</MenuItem>
                            <MenuItem key={1} value={'Masculino'}>Masculino</MenuItem>
                            <MenuItem key={2} value={'Femenino'}>Femenino</MenuItem>
                            <MenuItem key={3} value={'Binario'}>Binario</MenuItem>
                        </Select>
                        <FormHelperText>{this.state.errors.gender}</FormHelperText>
                    </FormControl>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha de Nacimiento"
                            views={["year", "month", "date"]}
                            disabled={this.state.disabled}
                            value={this.state.birthday}
                            onChange={(date) => {
                                this.handlerBirthDate(new Date(date));
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("birthday") ? this.state.errors.birthday !== "" : false}
                            helperText={this.state.errors.birthday}
                        />
                    </MuiPickersUtilsProvider>
                </div>

                <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>

                    <TextField
                        required
                        className={classes.date}
                        id="telephone-standard-required"
                        label="Teléfono 1"
                        type="text"
                        value={this.state.telephone1}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerTelephoneOne(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("telephone1") ? this.state.errors.telephone1 !== "" : false}
                        helperText={this.state.errors.telephone1}
                    />
                    <TextField
                        required
                        className={classes.date}
                        id="second-telephone-standard-required"
                        label="Teléfono 2"
                        type="text"
                        value={this.state.telephone2 !== null ? this.state.telephone2 : ""}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerTelephoneTwo(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("telephone2") ? this.state.errors.telephone2 !== "" : false}
                        helperText={this.state.errors.telephone2}
                    />
                    <TextField
                        required
                        className={classes.date}
                        id="cellphone-standard-required"
                        label="Celular"
                        type="text"
                        value={this.state.cellphone !== null ? this.state.cellphone : ""}
                        disabled={this.state.disabled}
                        onChange={(e) => {
                            this.handlerCellphone(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("cellphone") ? this.state.errors.cellphone !== "" : false}
                        helperText={this.state.errors.cellphone}
                    />
                </div>
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                    <h5>Datos Ubicación</h5>
                </div>
                <div>
                    <FormControl
                        className={classes.date}
                        error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                    >
                        <InputLabel id="country-status-select-label">País</InputLabel>
                        <Select
                            labelId="country-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.country}
                            disabled={this.state.disabled}
                            onChange={(event) => {
                                this.handlerCountry(event.target.value);
                            }}
                            error={this.state.errors.hasOwnProperty("country") ? this.state.errors.country !== "" : false}
                        >
                            <MenuItem key={1} value={38}>Colombia</MenuItem>
                        </Select>
                        <FormHelperText>{this.state.errors.country}</FormHelperText>
                    </FormControl>
                    <FormControl
                        className={classes.date}
                        error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                    >
                        <InputLabel id="department-status-select-label">Departamento</InputLabel>
                        <Select
                            labelId="department-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.department}
                            disabled={this.state.disabled}
                            onChange={(event) => {
                                this.handlerDepartment(event.target.value);
                            }}
                            error={this.state.errors.hasOwnProperty("department") ? this.state.errors.department !== "" : false}
                        >
                            {this.state.departments.map((department) => {
                                return <MenuItem key={department.id} value={department.depcod}>{department.depnom}</MenuItem>
                            })}
                        </Select>
                        <FormHelperText>{this.state.errors.department}</FormHelperText>
                    </FormControl>
                    <FormControl
                        className={classes.date}
                        error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                    >
                        <InputLabel id="city-status-select-label">Ciudad</InputLabel>
                        <Select
                            labelId="city-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.city}
                            disabled={this.state.disabled}
                            onChange={(event) => {
                                this.handlerCity(event.target.value);
                            }}
                            error={this.state.errors.hasOwnProperty("city") ? this.state.errors.city !== "" : false}
                        >
                            {this.state.cities.map((city) => {
                                return <MenuItem key={city.id} value={city.ciucod}>{city.ciunom}</MenuItem>
                            })}
                        </Select>
                        <FormHelperText>{this.state.errors.city}</FormHelperText>
                    </FormControl>
                    <TextField
                        required
                        className={classes.date}
                        id="address-standard-required"
                        label="Dirección"
                        type="text"
                        disabled={this.state.disabled}
                        value={this.state.address}
                        onChange={(e) => {
                            this.handlerAddress(e.target.value);
                        }}
                        error={this.state.errors.hasOwnProperty("address") ? this.state.errors.address !== "" : false}
                        helperText={this.state.errors.address}
                    />
                    <FormControl
                        className={classes.date}
                        style={{ width: 170, marginLeft: 10 }}
                    >
                        <InputLabel required id="demo-simple-select-label">Zona</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.zone}
                            disabled={this.state.disabled}
                            onChange={(event) => {
                                this.setState({ zone: event.target.value });
                            }}
                        >
                            <MenuItem key={1} value={'R'}>RURAL</MenuItem>
                            <MenuItem key={2} value={'U'}>URBANA</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                {this.state.exist ? (<div
                    style={{ margin: 10, color: '#4ce1b6', fontSize: 15 }}
                    variant="contained"
                    color="primary"
                    disabled={this.state.disabled}
                    onClick={() => {
                        //this.loadDataPatient();
                        this.setState({ exist: !this.state.exist })
                    }}
                >
                    Ver mas
                </div>) : (<div
                    style={{ margin: 10, color: '#4ce1b6', fontSize: 15 }}
                    onClick={() => {
                        //this.loadDataPatient();
                        this.setState({ exist: !this.state.exist })
                    }}
                >
                    Ver menos
                </div>)}
                {!this.state.exist ?
                    <React.Fragment>
                        <div style={{ marginLeft: 10 }}>
                            <h5>Datos Adicionales</h5>
                        </div>
                        <FormControl
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("civilStatus") ? this.state.errors.civilStatus !== "" : false}
                        >
                            <InputLabel id="civil-status-select-label">Estado Civil</InputLabel>
                            <Select
                                labelId="civil-status-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                disabled={this.state.disabled}
                                value={this.state.civilStatus}
                                onChange={(event) => {
                                    this.handlerCivilStatus(event.target.value);
                                }}
                                error={this.state.errors.hasOwnProperty("civilStatus") ? this.state.errors.civilStatus !== "" : false}
                            >
                                <MenuItem key={0} value={''}>Ninguno</MenuItem>
                                <MenuItem key={1} value={'Soltero'}>Soltero</MenuItem>
                                <MenuItem key={2} value={'Casado'}>Casado</MenuItem>
                                <MenuItem key={2} value={'Divorciado'}>Divorciado</MenuItem>
                                <MenuItem key={2} value={'Viudo'}>Viudo</MenuItem>
                                <MenuItem key={2} value={'Unión Libre'}>Unión Libre</MenuItem>
                            </Select>
                            <FormHelperText>{this.state.errors.civilStatus}</FormHelperText>
                        </FormControl>
                        <FormControl
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("regime") ? this.state.errors.regime !== "" : false}
                        >
                            <InputLabel id="regime-status-select-label">Regimen</InputLabel>
                            <Select
                                labelId="regime-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                disabled={this.state.disabled}
                                value={this.state.regime}
                                onChange={(event) => {
                                    this.handlerRegime(event.target.value);
                                }}
                                error={this.state.errors.hasOwnProperty("regime") ? this.state.errors.regime !== "" : false}
                            >
                                <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                {this.state.regimes.map((regime) => {
                                    return <MenuItem key={regime.id_regimen} value={regime.id_regimen}>{regime.regimen}</MenuItem>
                                })}
                            </Select>
                            <FormHelperText>{this.state.errors.regime}</FormHelperText>
                        </FormControl>
                        <FormControl
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("race") ? this.state.errors.race !== "" : false}
                        >
                            <InputLabel id="races-status-select-label">Raza</InputLabel>
                            <Select
                                labelId="races-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                disabled={this.state.disabled}
                                value={this.state.race}
                                onChange={(event) => {
                                    this.handlerRace(event.target.value);
                                }}
                                error={this.state.errors.hasOwnProperty("race") ? this.state.errors.race !== "" : false}
                            >
                                <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                {this.state.races.map((race) => {
                                    return <MenuItem key={race.id_raza} value={race.id_raza}>{race.raza}</MenuItem>
                                })}
                            </Select>
                            <FormHelperText>{this.state.errors.race}</FormHelperText>
                        </FormControl>
                        <FormControl
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("ethnicity") ? this.state.errors.ethnicity !== "" : false}
                        >
                            <InputLabel id="ethnicity-status-select-label">Etnia</InputLabel>
                            <Select
                                labelId="ethnicity-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                disabled={this.state.disabled}
                                value={this.state.ethnicity}
                                onChange={(event) => {
                                    this.handlerEthnicity(event.target.value);
                                }}
                                error={this.state.errors.hasOwnProperty("ethnicity") ? this.state.errors.ethnicity !== "" : false}
                            >
                                <MenuItem key={0} value={''}>Ninguna</MenuItem>
                                {this.state.ethnicities.map((ethnicity) => {
                                    return <MenuItem key={ethnicity.id_etnia} value={ethnicity.id_etnia}>{ethnicity.etnia}</MenuItem>
                                })}
                            </Select>
                            <FormHelperText>{this.state.errors.ethnicity}</FormHelperText>
                        </FormControl>
                        <FormControl
                            className={classes.date}
                            error={this.state.errors.hasOwnProperty("bloodType") ? this.state.errors.bloodType !== "" : false}
                        >
                            <InputLabel id="blood-type-select-label">Tipo de Sangre</InputLabel>
                            <Select
                                labelId="blood-type-select-label"
                                id="id-simple-select"
                                defaultValue={null}
                                disabled={this.state.disabled}
                                value={this.state.bloodType}
                                onChange={(event) => {
                                    this.handlerBloodType(event.target.value);
                                }}
                                error={this.state.errors.hasOwnProperty("bloodType") ? this.state.errors.bloodType !== "" : false}
                            >
                                <MenuItem key={0} value={'A+'}>A+</MenuItem>
                                <MenuItem key={1} value={'NACIONES UNIDAS-'}>NACIONES UNIDAS-</MenuItem>
                                <MenuItem key={2} value={'AB+'}>AB+</MenuItem>
                                <MenuItem key={3} value={'AB-'}>AB-</MenuItem>
                                <MenuItem key={4} value={'B+'}>B+</MenuItem>
                                <MenuItem key={5} value={'SEGUNDO-'}>SEGUNDO-</MenuItem>
                                <MenuItem key={6} value={'O+'}>O+</MenuItem>
                                <MenuItem key={7} value={'O-'}>O-</MenuItem>
                                <MenuItem key={8} value={''}>Sin definir</MenuItem>
                            </Select>
                            <FormHelperText>{this.state.errors.bloodType}</FormHelperText>
                        </FormControl>
                    </React.Fragment> : null}

                <div>
                    {this.state.profile === "9" || this.state.profile === "10" ?
                        this.state.disabled ?
                            <Button className={classes.date}
                                style={{ marginTop: 20 }}
                                variant="contained"
                                color="primary"

                                onClick={() => {
                                    this.setState({ disabled: false });
                                }}>
                                Habilitar Actualización 
                            </Button>
                            :
                            (<Button
                                className={classes.date}
                                style={{ marginTop: 20 }}
                                color="primary"
                                onClick={() => {
                                    this.validateData();
                                    if (!this.state.error) {
                                        //update data patient
                                        this.updatePatient();
                                    } else {
                                        console.log("Error datos incorrectos");
                                    }
                                }}
                            >
                                Actualizar Datos
                            </Button>) :
                        null
                    }
                </div>

                {this.state.openAlert ?
                    <ModalUI
                        color={this.state.modalAlert.color}
                        title={this.state.modalAlert.title}
                        message={this.state.modalAlert.message}
                        modal={this.state.openAlert}
                        toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                        onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                    /> : null}
                {this.state.load ?
                    <Modal
                        open={this.state.load}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div style={{
                            position: 'absolute',
                            backgroundColor: '#ffffff',
                            width: 200,
                            height: 200,
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%,-50%)',
                            display: 'flex'
                        }}
                        >
                            <div className="load__icon-wrap">
                                <svg className="load__icon">
                                    <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                </svg>
                            </div>
                        </div>
                    </Modal>
                    : null}
            </Col>
        )
    }
}

export default withStyles(styles, { withTheme: true })(BasicDataPatient);